<template>
  <div class="wrap">
    <div class="mb-2 tab-head mt-3">

      <a-input v-model:value="searchValue" class="search-input" :placeholder="$t('search')">
        <template #prefix>
          <search-outlined class="search-icon" />
        </template>
      </a-input>
      <div class="btns-wrap">
        <a-button v-if="isUserSuperadmin" @click="showAddUserHandler" size="large" type="primary"><plus-outlined />{{ $t('add') }}</a-button>
        <a-button @click="exportData" size="large">{{ $t('export') }}</a-button>
      </div>

    </div>
    <a-table
        :columns="columns"
        :data-source="filteredData"
        :pagination="{ ...pagination, locale: paginationLocale }"
        :scroll="{ x: 'max-content' }"
        :loading="loading"
        :show-header="!isMobileView"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'role'">
          <span>
            <a-tag
                class="table-tag red-tag"
            >
              {{ record.role }}
            </a-tag>
          </span>
        </template>
        <template v-if="column.key === 'access'">
          <span>
            <a-tag
                class="table-tag red-tag"
            >
              {{ record.access ? $t('granted') : $t('disabled') }}
            </a-tag>
          </span>
        </template>
        <template v-if="column.key === 'action'">
          <a-dropdown trigger="click">
            <a-button shape="circle" class="more-btn" @click.stop="handleActionClick(record)">
              <more-outlined />
            </a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item
                    @click="showInfoModalHandler"
                    key="1"
                >
                  <edit-outlined /> {{$t('edit')}} 
                </a-menu-item>
              </a-menu>
            </template>

          </a-dropdown>
        </template>
        <template v-if="column.key === 'all'">
          <a-card :title="$t('user')" class="table-card">
            <p class="user-card-row">
              <span>
                {{$t('full-name')}}
              </span>
              <span>{{record.name}}</span>
            </p>
            <p class="user-card-row">
              <span>
                {{$t('nickname')}}
              </span>
              <span>{{record.username}}</span>
            </p>
            <p class="user-card-row">
              <span>
                {{$t('email')}}
              </span>
              <span>{{record.email}}</span>
            </p>
            <p class="user-card-row">
              <span>
                {{$t('number')}}
              </span>
              <span>{{record.phone}}</span>
            </p>
            <p class="user-card-row">
              <span>
                {{$t('role')}}
              </span>
              <span>{{record.role}}</span>
            </p>
            <p class="user-card-row">
              <span>
                {{$t('actions')}}
              </span>
              <span>
                <a-dropdown trigger="click">
                  <a-button shape="circle" class="more-btn" @click.stop="handleActionClick(record)">
                    <more-outlined />
                  </a-button>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item
                          @click="showInfoModalHandler"
                          key="1"
                      >
                        {{ $t('more-info') }}
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </span>
            </p>
          </a-card>
        </template>
      </template>
    </a-table>
  </div>
  <EmergencyModal
      v-if="showAddUserModal"
      :show-modal="showAddUserModal"
      @update="handleAdd($event)"
      @close="handleCancelAdd"
  ></EmergencyModal>
  <EmergencyModal
      v-if="showInfoModal"
      :user-object="selectedUser"
      :show-modal="showInfoModal"
      :is-edit="true"
      @update="handleOkInfo($event)"
      @close="handleCancelInfo"
  ></EmergencyModal>
</template>

<script>
import {
  MoreOutlined,
  SearchOutlined,
  PlusOutlined,
  EditOutlined,
} from "@ant-design/icons-vue";
import EmergencyModal from "@/components/Modals/EmergencyModal";
import {notification} from "ant-design-vue";

export default {
  components: {
    MoreOutlined,
    SearchOutlined,
    PlusOutlined,
    EmergencyModal,
    EditOutlined
  },
  data() {
    return {
      searchValue: '',
      showAddUserModal: false,
      showInfoModal: false,
      selectedUser: {},
      user: JSON.parse(localStorage.getItem('user')),
      dataSource: [],
      loading: true,
      paginationLocale: {
        items_per_page: '/ stránce',
        jump_to: 'Přejít na',
        jump_to_confirm: 'Potvrdit',
        page: '',
        prev_page: 'Předchozí stránka',
        next_page: 'Další stránka',
        prev_5: 'Předchozích 5 stránek',
        next_5: 'Dalších 5 stránek',
        prev_3: 'Předchozí 3 stránky',
        next_3: 'Další 3 stránky',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 2,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} z ${total} položek`,
        onChange: this.handlePaginationChange,
        onShowSizeChange: this.handlePaginationChange,
      },
    };
  },
  computed: {
    filteredData() {
      if (!this.searchValue) {
        return this.dataSource
      }
      const filterTextLower = this.searchValue.toLowerCase();
      return this.dataSource.filter(item => {
        return Object.keys(item).some(key => {
          return String(item[key]).toLowerCase().includes(filterTextLower);
        });
      });
    },
    isUserSuperadmin() {
      return this.$store.getters['UserModule/user'].role === 'Superadmin'
    },
    isMobileView() {
      return this.$store.getters['isMobileView']
    },
    columns() {
      if (this.isMobileView) {
        return [
          {
            title: '',
            dataIndex: 'all',
            key: 'all'
          }
        ]
      }
      return [
        {
          title: this.$t('full-name'),
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: this.$t('nickname'),
          dataIndex: 'username',
          key: 'username',
        },
        {
          title: this.$t('email'),
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: this.$t('number'),
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: this.$t('role'),
          dataIndex: 'role',
          key: 'role',
        },
        {
          title: this.$t('access-app'),
          dataIndex: 'access',
          key: 'access',
        },
        {
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 150
        },
      ]
    }
  },
  async mounted() {
    if (this.$route.query.page) {
      this.pagination.current = +this.$route.query.page
    }
    if(this.$route.query.pageSize) {
      this.pagination.pageSize = +this.$route.query.pageSize;
    }
    await this.getUsersList()
  },
  methods: {
    async refreshView() {
      if (this.$route.query.page) {
        this.$route.query.page = 1
        this.pagination.current = 1
      }
      if(this.$route.query.pageSize) {
        this.pagination.pageSize = +this.$route.query.pageSize;
      }
      await this.getUsersList()
    },
    showInfoModalHandler() {
      if (this.isUserSuperadmin) {
        this.showInfoModal = true
      } else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    },
    showAddUserHandler() {
      if (this.isUserSuperadmin) {
        this.showAddUserModal = true
      } else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    },
    async getUsersList() {
      try {
        this.loading = true
        const path = this.$route.path;
        const { current, pageSize } = this.pagination;
        await this.$router.push({ path, query: { page: current, pageSize: pageSize} });
        const { data } = await this.$store.dispatch('Emergency/getUsersList', {
          page_size: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.dataSource = data.results
        this.loading = false
        this.pagination.current = data.current
        this.pagination.pageSize = data.page_size
        this.pagination.total = data.count
      } catch(e) {
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }
    },
    handlePaginationChange(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getUsersList();
    },
    handleActionClick(record) {
      this.selectedUser = record
    },
    async handleAdd(user) {
      try {
        await this.$store.dispatch('Emergency/createUser', user)
        await notification.success({
          message: this.$t('notifications.success'),
          description: this.$t('notifications.user-created'),
        })
        this.showAddUserModal = false
        this.refreshView()

      } catch (e) {
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }

    },
    handleCancelAdd() {
      this.showAddUserModal = false
    },
    async handleOkInfo(user) {
      // if superuser
      try {
        await this.$store.dispatch('Emergency/updateUser', user)
        await notification.success({
          message: this.$t('notifications.success'),
          description: this.$t('notifications.user-updated'),
        })
        this.showAddUserModal = false
        this.refreshView()

      } catch (e) {
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }
      // else just read
      this.showInfoModal = false
      this.selectedUser = {}
    },
    handleCancelInfo() {
      this.showInfoModal  = false
      this.selectedUser = {}
    },
    async exportData() {
      if (this.$store.getters['UserModule/user']?.user_permissions?.find(p => p.codename === 'export_user')) {
        try {
          const {data} = await this.$store.dispatch('Emergency/exportData', {
            users_uids: this.dataSource.map(s => s.uid)
          })
          window.open(data?.url, "_blank");
        } catch (e) {
          notification.error({
            message: this.$t('notifications.error'),
            description: e.response.data.errors[0].detail,
          })
        }
      } else if (this.isUserSuperadmin) {
        try {
          const {data} = await this.$store.dispatch('Emergency/exportData', {
            users_uids: this.dataSource.map(s => s.uid)
          })
          window.open(data?.url, "_blank");
        } catch (e) {
          notification.error({
            message: this.$t('notifications.error'),
            description: e.response.data.errors[0].detail,
          })
        }
      } else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/inputs.scss";
@import "~@/assets/scss/components/table-styles.scss";
.wrap {
  padding: 0 40px;
}
.tab-head {
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 800px) {
    flex-direction: column;
  }
}
</style>